module.exports = "<svg viewBox=\"0 0 24 24\" fill=\"#8b8b8b\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M18,14a4,4,0,0,0-3,1.38L9.91,12.84a3.86,3.86,0,0,0,0-1.67L15,8.62a4,4,0,1,0-.91-1.78L9,9.38a4,4,0,1,0,0,5.24l5.09,2.55A3.94,3.94,0,0,0,14,18a4,4,0,1,0,4-4Z\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/share.svg
// module id = 816
// module chunks = 1